enum DrivingState {
    DS_ACTIVE = 'DS_ACTIVE',
    DS_NOT_ACTIVE = 'DS_NOT_ACTIVE',
    DS_ERROR = 'DS_ERROR',
    DS_NOT_AVAILABLE = 'DS_NOT_AVAILABLE',
    NO_DATA = 'NO_DATA',
}

export default DrivingState;
